import React from 'react';
import PropTypes from 'prop-types';

import { BreadCrumbs, Title, Spacer, Visible, ImpersonatedUser } from 'src/core/components';

import './PageLayout.scss';

const PageLayoutComponent = ({
  title,
  subtitle,
  fullPage,
  titleContent,
  children: content,
}) => (
  <div className="layout">
    <BreadCrumbs />

    <Spacer top={42} />
    <div className="app-title">
      <Title size="1" message={title}>
        <ImpersonatedUser hasRightContent={!!titleContent} />
        {titleContent}
      </Title>
    </div>

    <Visible when={!!subtitle}>
      <div className="app-subtitle">
        <Spacer top={15} />
        <Title size="5" message={subtitle} thin />
      </div>
    </Visible>

    <Spacer bottom={28} />

    <div className={`main-content${fullPage ? ' full-main-content' : ''}`}>
      {content}
    </div>
  </div>
);

PageLayoutComponent.propTypes = {
  title: PropTypes.exact({
    id: PropTypes.string,
    defaultMessage: PropTypes.string
  }).isRequired,
  subtitle: PropTypes.exact({
    id: PropTypes.string,
    defaultMessage: PropTypes.string
  }),
  children: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.object,
    PropTypes.node,
    PropTypes.element
  ]),
  titleContent: PropTypes.element,
  fullPage: PropTypes.bool
};

export default PageLayoutComponent;
